import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { queryRequest } from "@/utils/request";
import { RootState } from "@/store";
import {
  getLuckyDrawDetail,
  wtDraw,
  sendTicket,
  queryChanceList,
  queryMemberLuckyDrawFrequency,
  queryMemberLuckyDrawTimes
} from "@/graphql/draw.gql";
import { queryDataDictionaryListLang } from "@/graphql/dictionary.gql";
import { isEmptyValue } from "@/utils/common";

// 01-活动限制总次数 11-每人限制总次数
export enum ActivityLimitEnums {
  ACTIVITY_TOTAL = "01",
  EACH_PERSON_LIMIT = "11"
}

// 13-每人限制单日次数 16-每人限制单周次数 17-每人限制单月次数
export enum ActivityLimitPeriodEnums {
  DAY = "13",
  WEEK = "16",
  MONTH = "17"
}

export interface DrawState {
  drawDetail: any;
}

@Module({ name: "DrawModule", namespaced: true })
export default class DrawModule
  extends VuexModule<DrawState, RootState>
  implements DrawState {
  // 抽奖详情
  public drawDetail: any = {};
  // 用户抽奖次数】
  public userDrawCount: number = 0;
  // 用户待激活抽奖次数
  public userWaitActivatedDrawCount: number = 0;

  @Mutation
  setDrawDetailMutation(data: any) {
    this.drawDetail = data || {};
  }
  @Mutation
  setUserDrawCountMutation(data: number) {
    this.userDrawCount = +data || 0;
  }
  @Mutation
  setUserWaitActivatedDrawCountMutation(data: number) {
    this.userWaitActivatedDrawCount = +data || 0;
  }

  // 抽奖详情
  @Action
  async getLuckyDrawDetailAction(variables: Object) {
    const data = await queryRequest({
      query: getLuckyDrawDetail,
      variables
    });
    this.context.commit("setDrawDetailMutation", data);
    return data;
  }

  // 抽奖
  @Action
  async drawAction(variables: Object) {
    return await queryRequest({
      query: wtDraw,
      variables
    });
  }

  @Action
  async sendTicketAction(variables: Object) {
    return await queryRequest({
      query: sendTicket,
      variables
    });
  }

  @Action
  async getDrawTemplateAction() {
    return await queryRequest({
      query: queryDataDictionaryListLang,
      variables: {
        input: { ddCode: "LUCKY_DRAW_TYPE" }
      }
    });
  }

  @Action
  async queryChanceAction(variables: any) {
    const count = await queryRequest({
      query: queryMemberLuckyDrawTimes,
      variables
    });
    this.context.commit("setUserDrawCountMutation", count);

    // const { dispatch } = this.context;
    // const p1 = dispatch("getLuckyDrawDetailAction", {
    //   activityCode: variables.activityCode
    // });
    // const p2 = queryRequest({
    //   query: queryMemberLuckyDrawFrequency,
    //   variables
    // });
    // const p3 = queryRequest({
    //   query: queryChanceList,
    //   variables: {
    //     ...variables,
    //     pageInput: { pageSize: 10, pageNum: 1 }
    //   }
    // });
    // const [detail, usedData = {}, remainingData = {}] = await Promise.all([
    //   p1,
    //   p2,
    //   p3
    // ]);
    // const activityLimitConfig = detail?.incentiveLimiteds || [];
    // const getLimitValue = (code: string) => {
    //   return (activityLimitConfig.find(o => o.limitationCode === code) || {})
    //     .limitationValue;
    // };
    // const activityTotal = getLimitValue(ActivityLimitEnums.ACTIVITY_TOTAL);
    // const eachPersonLimit = getLimitValue(ActivityLimitEnums.EACH_PERSON_LIMIT);
    // const periodKey: string = Object.keys(ActivityLimitPeriodEnums).filter(
    //   key => !isEmptyValue(getLimitValue(ActivityLimitPeriodEnums[key]))
    // )[0];
    // let periodTotal = periodKey
    //   ? getLimitValue(ActivityLimitPeriodEnums[periodKey])
    //   : undefined;
    // // const { day, week, month, total, activityCode } = usedData;
    // const periodUsedCount = periodKey
    //   ? usedData[periodKey.toLocaleLowerCase()]
    //   : undefined;
    // const personUsedCount = usedData.total;
    // const activityRemainingCount = usedData.activityCode; // 活动总剩余次数
    // const {
    //   dataList: [data]
    // } = remainingData;
    // const remainingCount = +data?.data?.times || 0; //此人，此活动，剩余抽奖次数，这里需要默认为0
    // console.log("---------------------活动次数限制设置---------------------");
    // console.log("活动总次数：", activityTotal);
    // console.log("每人最大抽奖次数：", eachPersonLimit);
    // console.log("周期类型", periodKey);
    // console.log("每人周期最大抽奖次数", periodTotal);
    // console.log("---------------------此人次数相关数据---------------------");
    // console.log("此人周期内已抽奖次数：", periodUsedCount);
    // console.log("此人此活动已抽奖次数：", personUsedCount);
    // console.log("此人此活动剩余次数：", remainingCount);
    // console.log("此活动总共剩余次数：", activityRemainingCount);
    // console.log("---------------------取以下最小值---------------------");
    // console.log("活动总次数：", activityTotal);
    // console.log("此活动总共剩余次数：", activityRemainingCount);
    // console.log("此人此活动剩余次数：", remainingCount);
    // console.log(
    //   "每人最大抽奖次数 - 此人此活动已抽奖次数",
    //   eachPersonLimit - personUsedCount
    // );
    // console.log(
    //   "周期内总剩余次数：",
    //   periodTotal ? periodTotal - periodUsedCount : undefined
    // );
    // const minArr = [
    //   activityTotal,
    //   eachPersonLimit - personUsedCount, // 每人最大次数 - 已抽的次数
    //   activityRemainingCount, // 活动总共剩余次数
    //   remainingCount, // 此人，此活动，剩余次数
    //   periodTotal ? periodTotal - periodUsedCount : undefined // 周期内总剩余次数
    // ]
    //   .filter(o => !isEmptyValue(o))
    //   .filter(o => !Number.isNaN(o));
    // console.log("比较最小值：", minArr);
    // const finalRemainingCount = Math.min(...minArr);
    // console.log("---------------------结果---------------------");
    // console.log("最小值为：", finalRemainingCount);
    // this.context.commit("setUserDrawCountMutation", finalRemainingCount);
  }

  @Action
  async queryWaitActivatedAction(variables: any) {
    const res = await queryRequest({
      query: queryChanceList,
      variables: {
        ...variables,
        pageInput: { pageSize: 10, pageNum: 1 }
      }
    });
    const {
      dataList: [data]
    } = res;
    this.context.commit(
      "setUserWaitActivatedDrawCountMutation",
      data?.data?.frozenCount
    );
  }
}
